import { Venues } from '@weddingspot/ws-api-client';

import * as constants from '../constants';
import { VenueProfile } from '../types/venue-profile';
import { VenueProfileAction } from '../actions/venue-profile';

export function venueProfile(
    state: VenueProfile = {
        id: 0,
        csn_venue_id: undefined,
        market: '',
        max_capacity: 0,
        images: [],
        activeSlide: 0,
        name: '',
        description: '',
        description_rds: null,
        styles: [],
        services: [],
        services_rds: [],
        capacity: [],
        packages: [],
        province: null,
        zip_code: '',
        country: '',
        is_destination: false,
        starting_price_per_person_rds: 0,
        timeRestrictions: [],
        catering: [],
        alcohol: [],
        cost_max: 0,
        cost_min: 0,
        region: '',
        website: '',
        ceremony: '',
        reception: '',
        wedding_spot_awards_years: [],
        awards: [],
        time_restrictions_str: '',
        rental_fee_description: '',
        availability: null,
        phone_number: '',
        amenities: [],
        special_restrictions: [],
        hide_wedding_costs: false,
        hide_guest_rooms: false,
        latitude: 0,
        last_updated_date: '',
        longitude: 0,
        state: '',
        city: '',
        address_1: '',
        address_2: '',
        is_favorite: false,
        is_priced: true,
        isMoreTabOpen: false,
        isPhoneShown: false,
        activeTabIndex: 0,
        videos: [],
        no_longer_doing_weddings: false,
        profileLoaded: false,
        budgetCapacity: null,
        budgetRangeMin: null,
        userSpotEstimate: null,
        venueHighlights: [],
        discounts: [],
        facebookLink: null,
        instagramLink: null,
        pinterestLink: null,
        recommendations: [],
        recommendationsLoadSucceeded: undefined,
        disableRecommendations: false,
        inquiryModalShowing: false,
        has_weddings: false,
        has_rds: false,
        renderRdv: false,
        upcoming_events: [],
        showAdditionalPriceVenueButton: false,
        testFlagDetails: false,
        testFlagPersonalized: false,
        persinalizedInfoLoadSucceeded: undefined,
        is_not_available: false,
    },
    action: VenueProfileAction
) {
    switch (action.type) {
        case constants.LOAD_VENUE_DETAILS:
            const venueDetails: Partial<Venues.VenueDetails> = action.payload;
            let mappedAvailability: { [date: string]: number } | null = null;
            if (venueDetails.availability) {
                mappedAvailability = venueDetails.availability.reduce((prev, [date, _, status]) => {
                    prev[date] = status;
                    return prev;
                }, {});
            }
            return {
                ...state,
                ...action.payload,
                availability: mappedAvailability,
                budgetRangeMin: action.payload.budget_range ? action.payload.budget_range.min : null,
                budgetCapacity: action.payload.budget_range ? action.payload.budget_range.capacity : null,
                profileLoaded: true,
                venueHighlights: action.payload.venue_highlights.map((item, idx) => {
                    return {
                        name: item.name,
                        label: item.label,
                        iconUrl: item.icon_url,
                    };
                }),
                discounts: !!action.payload.discount ? [action.payload.discount] : [],
                facebookLink: action.payload.facebook_link,
                instagramLink: action.payload.instagram_link,
                pinterestLink: action.payload.pinterest_link,
                disableRecommendations: action.payload.disable_recommendations,
                testFlagDetails: action.payload.test_flag,
                is_not_available: false,
            };
        case constants.LOAD_PERSONALIZED_VENUE_DETAILS:
            const details = action.payload;
            return {
                ...state,
                estimateCompleted: details.estimate_completed,
                notifications: details.notifications,
                userSpotEstimate: details.spot_estimate,
                is_favorite: details.is_favorite,
                showAdditionalPriceVenueButton: details.show_additional_price_venue_button,
                showGuestRoomsRecommendations: details.guest_rooms_recommendations,
                showWsRfpForm: details.ws_rfp_form,
                showSleepingRoomsOnVenueProfile: details.test_sleeping_rooms_on_venue_profile,
                testFlagPersonalized: details.test_flag,
                persinalizedInfoLoadSucceeded: true,
                testGuestRoomsIntentCta: action.payload.test_guest_rooms_intent_cta,
                intentCTAonPostOutreachStep1: action.payload.intent_CTA_on_post_outreach_step_1,
                simplifyOutreachTestValue2: action.payload.test_outreach_reduce_pt_2,
                intentCTAStepRemoved: action.payload.intent_cta_step_removed,
            };
        case constants.NEXT_VENUE_IMAGES_SLIDE:
            return {
                ...state,
                activeSlide: ((state.activeSlide + 1) % state.images.length) + 1,
            };
        case constants.PREV_VENUE_IMAGES_SLIDE:
            return {
                ...state,
                activeSlide: ((state.activeSlide + state.images.length) % state.images.length) + 1,
            };
        case constants.SHOW_PHONE_NUMBER:
            return {
                ...state,
                isPhoneShown: true,
            };
        case constants.SET_ACTIVE_TAB:
            return {
                ...state,
                activeTabIndex: action.payload,
            };
        case constants.OPEN_MORE_TAB:
            return {
                ...state,
                isMoreTabOpen: true,
            };
        case constants.CLOSE_MORE_TAB:
            return {
                ...state,
                isMoreTabOpen: false,
            };
        case constants.SET_VENUE_AS_FAVORITE:
            return {
                ...state,
                is_favorite: true,
            };
        case constants.UNSET_VENUE_FROM_FAVORITE:
            return {
                ...state,
                is_favorite: false,
            };
        case constants.VENUE_PROFILE_RECOMMENDATIONS_LOADED:
            const recs = action.payload || [];
            return {
                ...state,
                recommendations: recs,
                recommendationsLoadSucceeded: true,
            };
        case constants.VENUE_PROFILE_RECOMMENDATIONS_FAILED:
            return {
                ...state,
                recommendations: [],
                recommendationsLoadSucceeded: false,
            };
        case constants.VENUE_PROFILE_SHOW_INQUIRY_MODAL:
            return {
                ...state,
                inquiryModalShowing: true,
            };
        case constants.VENUE_PROFILE_HIDE_INQUIRY_MODAL:
            return {
                ...state,
                inquiryModalShowing: false,
            };
        case constants.VENUE_PROFILE_RENDER_RDV:
            return {
                ...state,
                renderRdv: true,
            };
        case constants.LOAD_UNLISTED_VENUE:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
}

export default venueProfile;
